import { render, staticRenderFns } from "./ubicaciones.vue?vue&type=template&id=8c06d9d6"
import script from "./ubicaciones.vue?vue&type=script&lang=js"
export * from "./ubicaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports